import { Component, OnInit, ViewChild, AfterViewInit, AfterViewChecked } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalComponent } from '../modal/modal.component';
import { CommonService } from '../common.service';
import { Profile } from 'profile-api';

@Component({
    selector: 'app-reserved-area',
    templateUrl: './reserved-area.component.html',
    styleUrls: ['./reserved-area.component.css']
})
export class ReservedAreaComponent implements OnInit, AfterViewInit, AfterViewChecked {

    @ViewChild('fromTenderModal') fromTenderModal: ModalComponent;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private commonService: CommonService
    ) { }

    loadDashboard: boolean = true;
    loadMyTenders: boolean = false;
    loadMyPartecipations: boolean = false;
    loadProfile: boolean = false;
    loadPaymentMethod: boolean = false;
    loadPrepaidPackets: boolean = false;
    loadTenderDetail: boolean = false;
    loadAnnouncementDetail: boolean = false;
    loadParticipationDetail: boolean = false;
    loadMyAnnouncements: boolean = false;
    loadTenderQuestionsAndAnswers: boolean = false;
    loadParticipationQuestionsAndAnswers: boolean = false;
    modalMessage: string;
    tenderId: number;
    openedFrom: string;
    participationId: number;
    fromTender: boolean = false;
    fromClusterTender: boolean = false;
    fromPrepaidPacketBuy: boolean = false;
    fromQuoteBuy: boolean = false;
    fromPrepaidPacket: boolean = false;
    isTenderPacket: boolean;
    userName: string;
    tenderTitle: string;
    editable: string;
    modalAlreayOpened: boolean;
    profile: Profile;

    ngOnInit() {
        this.commonService.getProfile().then((profile: Profile) => {
            this.profile = profile;
            this.userName = profile.username;
            this.modalAlreayOpened = false;
            this.route.queryParams.subscribe(params => {
                // console.log("PARAMS",params)
                this.tenderId = params['tenderId'];
                this.openedFrom = params['openedFrom'];
                this.tenderTitle = params['tenderTitle'];
                this.participationId = params['participationId'];
                this.editable = params['editable'];
                const toLoadArea = params['tabToLoad'];
                // console.log(toLoadArea)
                if (params['fromTender']) {
                    this.fromTender = true;
                }
                if (params['fromClusterTender']) {
                    this.fromClusterTender = true;
                }
                if (params['fromPrepaidPacketBuy']) {
                    this.fromPrepaidPacketBuy = true;
                }
                if (params['fromQuoteBuy']) {
                    this.fromQuoteBuy = true;
                }
                if (params['fromPrepaidPacket']) {
                    this.fromPrepaidPacket = true;
                }
                let isTender = params['isTenderPacket'];
                if (isTender) {
                    if (isTender === 'true') {
                        this.isTenderPacket = true;
                    } else {
                        this.isTenderPacket = false;
                    }
                }
                if (toLoadArea) {
                    this.loadTab(toLoadArea);
                }
            });
        }).catch(
            (error) => {
                console.log("User not logged in. Cannot access reserved area.")
                window.open('/accessonegatoareariservata', '_self');
            }
        );

    }

    ngAfterViewInit() {
        this.openFromTenderModal();
    }

    ngAfterViewChecked() {
        //this.openFromTenderModal();
    }

    openFromTenderModal() {
        if (!this.modalAlreayOpened && this.fromTenderModal && (this.fromTender || this.fromClusterTender || this.fromPrepaidPacketBuy || this.fromQuoteBuy || this.fromPrepaidPacket)) {
            this.fromTenderModal.open();
            this.modalAlreayOpened = true;
        }
    }

    openTab(toOpenArea: string) {
        this.fromPrepaidPacketBuy = false;
        this.fromTender = false;
        this.fromClusterTender = false;
        this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": toOpenArea } });
        //window.open('/areariservata?tabToLoad=' + toOpenArea,'_self');
    }

    loadTab(toLoadArea: string) {
        if (toLoadArea) {
            if (toLoadArea === 'dashboard') {
                this.openDashboard();
            } else if (toLoadArea === 'profile') {
                if (this.fromTender || this.fromClusterTender) {
                    this.modalMessage = "Per poter procedere all'acquisto della gara è necessario compilare tutti i dati obbligatori del profilo.";
                } else if (this.fromPrepaidPacketBuy || this.fromPrepaidPacket) {
                    this.modalMessage = "Per poter procedere all'acquisto di un abbonamento è necessario compilare tutti i dati obbligatori del profilo.";
                } else if (this.fromQuoteBuy) {
                    this.modalMessage = "Per poter procedere all'acquisto del preventivo è necessario compilare tutti i dati obbligatori del profilo.";
                }
                this.openProfile();
            } else if (toLoadArea === 'paymentMethod') {
                if (this.fromTender || this.fromClusterTender) {
                    this.modalMessage = "Per poter procedere all'acquisto della gara è necessario impostare un metodo di pagamento.";
                } else if (this.fromPrepaidPacketBuy) {
                    this.modalMessage = "Per poter procedere all'acquisto di un abbonamento è necessario impostare un metodo di pagamento.";
                } else if (this.fromQuoteBuy) {
                    this.modalMessage = "Per poter procedere all'acquisto di un abbonamento è necessario impostare un metodo di pagamento.";
                }
                this.openPaymentMethod();
            } else if (toLoadArea === 'tenders') {
                this.openMyTenders();
            } else if (toLoadArea === 'tenderDetail') {
                this.openTenderDetail();
            } else if (toLoadArea === 'myParticipations') {
                this.openMyPartecipations();
            } else if (toLoadArea === 'participationDetail') {
                this.openParticipationDetail();
            } else if (toLoadArea === 'prepaidPackets') {
                this.openPrepaidPackets();
            } else if (toLoadArea === 'announcements') {
                this.openMyAnnouncements();
            } else if (toLoadArea === 'announcementDetail') {
                this.openAnnouncementDetail();
            } else if (toLoadArea === 'tenderQuestionsAndAnswers') {
                this.openTenderQuestionsAndAnswers();
            } else if (toLoadArea === 'participationQuestionsAndAnswers') {
                this.openParticipationQuestionsAndAnswers();
            }
        }
    }

    logout() {
        localStorage.removeItem('TEMP_TENDER');
        if (localStorage.getItem('TOKEN') != null) {
            this.commonService.logout();
        }
        window.open('/logout', '_self');
    }

    resetComponentLoading() {
        this.loadDashboard = false;
        this.loadMyTenders = false;
        this.loadMyPartecipations = false;
        this.loadProfile = false;
        this.loadPaymentMethod = false;
        this.loadPrepaidPackets = false;
        this.loadTenderDetail = false;
        this.loadAnnouncementDetail = false;
        this.loadParticipationDetail = false;
        this.loadMyAnnouncements = false;
        this.loadTenderQuestionsAndAnswers = false;
        this.loadParticipationQuestionsAndAnswers = false;
        let element = document.getElementById("fusion-tab-dashboard").parentElement;
        element.className = element.className.replace(/\bactive\b/g, "");
        element = document.getElementById("fusion-tab-lemiegare").parentElement;
        element.className = element.className.replace(/\bactive\b/g, "");
        element = document.getElementById("fusion-tab-lemiepartecipazioni").parentElement;
        element.className = element.className.replace(/\bactive\b/g, "");
        element = document.getElementById("fusion-tab-profilo").parentElement;
        element.className = element.className.replace(/\bactive\b/g, "");
        element = document.getElementById("fusion-tab-carta-di-credito").parentElement;
        element.className = element.className.replace(/\bactive\b/g, "");
        element = document.getElementById("fusion-tab-pacchettiprepagati").parentElement;
        element.className = element.className.replace(/\bactive\b/g, "");
        element = document.getElementById("fusion-tab-imieiannunci").parentElement;
        element.className = element.className.replace(/\bactive\b/g, "");
    }

    addActiveStyle(element: HTMLElement) {
        let name = "active";
        let arr = element.className.split(" ");
        if (arr.indexOf(name) == -1) {
            element.className += " " + name;
        }
    }

    openDashboard() {
        this.resetComponentLoading();
        this.loadDashboard = true;
        let element = document.getElementById("fusion-tab-dashboard").parentElement;
        this.addActiveStyle(element);
    }

    openMyTenders() {
        this.resetComponentLoading();
        this.loadMyTenders = true;
        let element = document.getElementById("fusion-tab-lemiegare").parentElement;
        this.addActiveStyle(element);
    }

    openMyPartecipations() {
        this.resetComponentLoading();
        this.loadMyPartecipations = true;
        let element = document.getElementById("fusion-tab-lemiepartecipazioni").parentElement;
        this.addActiveStyle(element);
    }

    openProfile() {
        this.resetComponentLoading();
        this.loadProfile = true;
        let element = document.getElementById("fusion-tab-profilo").parentElement;
        this.addActiveStyle(element);
        this.openFromTenderModal();
    }

    openPaymentMethod() {
        this.resetComponentLoading();
        this.loadPaymentMethod = true;
        let element = document.getElementById("fusion-tab-carta-di-credito").parentElement;
        this.addActiveStyle(element);
        this.openFromTenderModal();
    }

    openPrepaidPackets() {
        //reload profile before trying to access prepaid method
        this.commonService.getProfile().then((profile: Profile) => {
            this.profile = profile;
            this.userName = profile.username;
            this.resetComponentLoading();

            //Open prepaidPacket tab only if profile is complete: it's necessary to know if user is private or no
            this.commonService.saveProfile(this.profile).then(
                (pro: Profile) => {
                    this.loadPrepaidPackets = true;
                    let element = document.getElementById("fusion-tab-pacchettiprepagati").parentElement;
                    this.addActiveStyle(element);
                }
            ).catch(
                (error) => {
                    this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'profile', "fromPrepaidPacket": 'yes' } });
                }
            );
        }).catch(
            (error) => {
                console.log("User not logged in. Cannot access reserved area.")
                window.open('/accessonegatoareariservata', '_self');
            }
        );
    }

    openMyAnnouncements() {
        this.resetComponentLoading();
        this.loadMyAnnouncements = true;
        let element = document.getElementById("fusion-tab-imieiannunci").parentElement;
        this.addActiveStyle(element);
    }

    openAnnouncementDetail() {
        this.resetComponentLoading();
        this.loadAnnouncementDetail = true;
        let element = document.getElementById("fusion-tab-imieiannunci").parentElement;
        this.addActiveStyle(element);
    }

    openTenderDetail() {
        this.resetComponentLoading();
        this.loadTenderDetail = true;
        let element = document.getElementById("fusion-tab-lemiegare").parentElement;
        this.addActiveStyle(element);
    }

    openParticipationDetail() {
        this.resetComponentLoading();
        this.loadParticipationDetail = true;
        let element = document.getElementById("fusion-tab-lemiepartecipazioni").parentElement;
        this.addActiveStyle(element);
    }

    openTenderQuestionsAndAnswers() {
        this.resetComponentLoading();
        this.loadTenderQuestionsAndAnswers = true;
        let element = null;
        if (this.openedFrom === 'tender') {
            element = document.getElementById("fusion-tab-lemiegare").parentElement;
        } if (this.openedFrom === 'participation') {
            element = document.getElementById("fusion-tab-lemiepartecipazioni").parentElement;
        }
        this.addActiveStyle(element);
    }

    openParticipationQuestionsAndAnswers() {
        this.resetComponentLoading();
        this.loadParticipationQuestionsAndAnswers = true;
        let element = null;
        if (this.openedFrom === 'tender') {
            element = document.getElementById("fusion-tab-lemiegare").parentElement;
        } if (this.openedFrom === 'participation') {
            element = document.getElementById("fusion-tab-lemiepartecipazioni").parentElement;
        }
        this.addActiveStyle(element);
    }

    closeFromTenderModal() {
        this.modalAlreayOpened = false;
        this.fromTenderModal.close();
    }
}
